export function Metric({ label, value, hint, testId }) {
  return (
    <div data-testid={testId} className="cre-surface rounded-sm p-5">
      <div className="cre-overline">{label}</div>
      <div className="mt-1 font-heading text-4xl font-black tracking-tighter text-slate-900">
        {value}
      </div>
      {hint ? <div className="mt-1 text-xs text-zinc-500">{hint}</div> : null}
    </div>
  );
}

export const STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "pending_approval", label: "Pending approval" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "closed", label: "Closed" },
  { value: "resolved", label: "Resolved" },
  { value: "analyzing", label: "Analyzing" },
];

export const SETTABLE_STATUSES = [
  "awaiting_approval",
  "approved",
  "rejected",
  "closed",
  "resolved",
];

const STATUS_BADGE = {
  pending_analysis: "bg-slate-100 text-slate-700",
  analyzing: "bg-sky-100 text-sky-700",
  awaiting_approval: "bg-amber-100 text-amber-700",
  approved: "bg-emerald-100 text-emerald-700",
  rejected: "bg-rose-100 text-rose-700",
  modified: "bg-violet-100 text-violet-700",
  closed: "bg-slate-200 text-slate-800",
  resolved: "bg-teal-100 text-teal-700",
};

export function StatusPill({ status }) {
  return (
    <span
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider ${
        STATUS_BADGE[status] || "bg-slate-100 text-slate-700"
      }`}
    >
      {status?.replaceAll("_", " ")}
    </span>
  );
}
